export async function getArchivo(archivoUrl) {
  const authToken = sessionStorage.getItem( 'token' );
  try {
    const response = await fetch(`https://app.tavad.com/hce/wp-json/tavad/v2/archivo?url=${archivoUrl}`, {
      method: 'GET',
      headers: {
      'Authorization': `Bearer ${ authToken }`,
      },
    } );
    const blob = await response.blob();
    return blob;
  } catch (error) {
    console.error(error);
  }
}
